import { render, staticRenderFns } from "./MyExternalTasks.vue?vue&type=template&id=380ac56e&scoped=true"
import script from "./MyExternalTasks.vue?vue&type=script&lang=js"
export * from "./MyExternalTasks.vue?vue&type=script&lang=js"
import style0 from "./MyExternalTasks.vue?vue&type=style&index=0&id=380ac56e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380ac56e",
  null
  
)

export default component.exports